/* eslint-disable react/prop-types */
/* eslint-disable react/no-danger */

import Head from 'next/head';
import { NextSeo } from 'next-seo';

const SEO = ({ title, description, openGraph, url, schema }) => {
  return (
    <>
      <NextSeo title={title} description={description} openGraph={openGraph} />
      <Head>
        <title>{title}</title>
        {schema && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(schema)
            }}
          />
        )}
        {url && <link key="canonical" rel="canonical" href={url} />}
      </Head>
    </>
  );
};

export default SEO;
